import { useRef, useState } from 'react'
import clsx from 'clsx'
import reactStringReplace from 'react-string-replace'

import { ContentModal } from 'components/organisms/modals/content-modal'
import TermsContent, { Term } from './TermsContent'

interface Props {
	label: any
	params?: any
}

export function TermsOfServiceAndPrivacyBlock({ label, params }: Props) {
	const scrollToRef = useRef<HTMLDivElement>(null)
	const [openModal, setOpenModal] = useState<boolean>(false)
	const [term, setTerm] = useState<string>('')

	const renderLabel = () =>
		reactStringReplace(label, /#(\w+)/g, (match, i) => (
			<a
				key={i}
				className="text-link cursor-pointer"
				onClick={() => {
					setTerm(match === 'termsOfService' ? 'Terms of Service' : 'Privacy Policy')
					setOpenModal(true)
					setTimeout(() => {
						scrollToRef.current?.scrollTo(0, 0)
					}, 100)
				}}
			>
				{params[match]}
			</a>
		))

	return (
		<div>
			<div className="flex justify-start">
				<span className="transition-all duration-300 text-sm text-center px-4">{renderLabel()}</span>
			</div>
			<ContentModal title={term} open={openModal} setOpen={setOpenModal} hideCloseButton size="lg">
				<div className="text-left h-[calc(100vh-300px)] overflow-auto text-wrap" ref={scrollToRef}>
					<div className={clsx({ hidden: term === 'Privacy Policy' })}>
						<TermsContent term={Term.TermsOfService} />
					</div>
					<div className={clsx({ hidden: term === 'Terms of Service' })}>
						<TermsContent term={Term.PrivacyPolicy} />
					</div>
				</div>
				<div className="mt-10 flex justify-center">
					<button
						onClick={() => {
							setOpenModal(false)
						}}
						className="w-32 h-10 rounded-full flex justify-center items-center transition-all duration-300 bg-primary text-white font-bold hover:bg-primary-hover disabled:bg-white-25 disabled:text-white-25 disabled:backdrop-blur-lg"
					>
						OK
					</button>
				</div>
			</ContentModal>
		</div>
	)
}
